export default "__VITE_ASSET__B7uE6vDK__"